export interface StructuredDataInfo {
  year: number;
  title: string;
  mealPrice: string;
  menuAccountingOfficer: string;
  mealPriceTitle: string;
}

export interface StructuredData {
  data: {
    tax: number;
    info: StructuredDataInfo;
    menu: {
      dishes: string[];
      weekDay: number;
      datetime: string;
      afternoons: string[];
      studentCount: number;
      note: string;
    };
    items: {
      name: string;
      unit: string;
      price: number;
      quantity: number;
      totalAmount: number;
    }[];
    total: number;
    income: {
      price: number;
      quantity: number;
      totalAmount: number;
    };
    remain: number;
    outcome: {
      quantity: number;
      totalAmount: number;
    };
    incomeAfterTax: number;
    remainYesterday: number;
    remainNextDay: number;
  };
  metadata: {
    isUsed: boolean;
    hasAfternoon?: boolean;
    /**
     * - offset: 'loại 1'
     *
     * - revenue: 'loại 2'
     */
    settlementStatementType: 'offset' | 'revenue';
  };
}

export type DailyInvoiceModel = {
  searchStr: string;
  structuredData: StructuredData;
  metadata: {
    v20241121: {
      day: number;
      week: number;
      year: number;
      month: number;
      state: SettlementStatementOperationEnum;
    };
  };
  parentId: string;
  type: string;
  deletedAt: string | null;
  updatedAt: string;
};

export interface DailyInvoiceFilterModel {
  date?: string;
  state?: SettlementStatementOperationEnum;
  template?: string;
}

export enum SettlementStatementOperationEnum {
  confirm = 'confirm',
  complete = 'complete',
}
